import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./style.css";
import "remixicon/fonts/remixicon.css";
import "@fortawesome/fontawesome-free/css/all.css";
import { useAuthStore } from "./stores/auth";
import { createHead } from "@vueuse/head";

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

// Initialize auth store before mounting
const authStore = useAuthStore(pinia);

// Wait for auth to be ready before mounting
authStore
	.init()
	.then(() => {
		app.use(router);
		app.use(createHead());
		app.mount("#app");
	})
	.catch((error) => {
		console.error("Failed to initialize auth:", error);
		// Mount the app anyway to show error state
		app.use(router);
		app.mount("#app");
	});

// Toast configuration
const options = {
	position: "top-right",
	timeout: 3000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: false,
	closeButton: "button",
	icon: true,
	rtl: false,
};

// Add error handling for uncaught promises
window.addEventListener("unhandledrejection", (event) => {
	console.error("Unhandled promise rejection:", event.reason);
});
